

















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import ChartLine from './ChartLine.vue'
import DateRangePicker from 'vue2-daterange-picker'
import { localeData } from '../../../../helpers/date-range'
import customRange from '../../../../helpers/date-range'
import UserExam from '../../models/user_exam'
import Exam from '../../models/exam'

@Component({
  components: {
    ChartLine,
    DateRangePicker
  }
})
export default class ExamDashboardChart extends Vue {
  redColor = 'rgb(255, 87, 51)'
  dotRedColor = '#FFB1A9'
  blueColor = 'rgb(124, 181, 236)'
  dotBlueColor = '#ACCFE5'
  maxDate = new Date()

  @Prop({ required: true }) exams: Exam[]
  @Prop({ required: false }) startDate: string
  @Prop({ required: false }) endDate: string

  get allCompletedUserExams() {
    let list: { userExam: UserExam; exam: Exam }[] = []
    this.exams.filter((exam)=>{
      return !exam.hideResult
    }).forEach((exam) => {
      list = [
        ...list,
        ...exam.completedUserExams.map((userExam) => {
          return { userExam, exam }
        })
      ]
    })

    list.sort((a, b) => (a.userExam.createdAt > b.userExam.createdAt ? 1 : -1))

    return list
  }

  get userExamsInrange() {
    return this.allCompletedUserExams.filter(
      (userExam) =>
        userExam.userExam.createdAt > new Date(this.dateRange.startDate) && userExam.userExam.createdAt < new Date(this.dateRange.endDate)
    )
  }

  @Watch('startDate')
  changeRangeDate() {
    this.dateRange.startDate = this.startDate
    this.dateRange.endDate = this.endDate
  }

  data:  {
    labels: string[];
    datasets: any[];
} = {
    labels: [],
    datasets: []
  }

  options = {
    line: {
      tension: 0
    },
    scales: {
      x: [{
        display: !checkMobile() //this will remove all the x-axis grid lines
      }],
      y: [
        {
          id: 'A',
          type: 'linear',
          position: 'left',
          ticks: {
            fontColor: this.redColor
          },
        },
        {
          id: 'B',
          type: 'linear',
          position: 'right',
          ticks: {
            fontColor: this.blueColor,
            reverse: true
          }
        }
      ]
    }
  }

  get customRange() {
    return customRange()
  }

  // dateRange = {
  //   startDate: this.startDate,
  //   endDate: this.endDate
  // }
  dateRange = {
    startDate: '',
    endDate: ''
  }

  localeData = localeData
  isMobile: boolean = false

  created() {
    this.isMobile = checkMobile()
    this.updateDateRange()
  }

  @Watch('exams')
  onExamsChange(newVal) {
    this.updateDateRange()
  }

  async updateDateRange() {
    const labels: string[] = []

    const userScore: {
      label: string;
      borderColor: string;
      data: number[];
      fill: boolean;
      yAxisID: string;
      lineTension: number;
    } = {
      label: 'あなたのスコア',
      borderColor: this.redColor,
      data: [],
      fill: false,
      yAxisID: 'A',
      lineTension: 0,
      // borderWidth: 8,
      // pointBorderWidth: 18
    }

    const examScoreAverage: {
      label: string;
      borderColor: string;
      data: number[];
      fill: boolean;
      yAxisID: string;
      lineTension: number;
      borderDash: number[];
      hidden: boolean;
    } = {
      label: '平均',
      borderColor: this.dotRedColor,
      data: [],
      fill: false,
      yAxisID: 'A',
      lineTension: 0,
      // borderWidth: 5,
      borderDash: [10, 10],
      hidden: true,
    }

    const userRank: {
    label: string;
    borderColor: string;
    data: number[];
    fill: boolean;
    yAxisID: string;
    lineTension: number;
    hidden: boolean;
} = {
      label: 'あなたの順位',
      borderColor: this.blueColor,
      data: [],
      fill: false,
      yAxisID: 'B',
      lineTension: 0,
      hidden: true,
      // borderWidth: 8,
      // pointBorderWidth: 18
    }

    const examUserCount: {
    label: string;
    borderColor: string;
    data: number[];
    fill: boolean;
    yAxisID: string;
    lineTension: number;
    borderDash: number[];
    hidden: boolean;
} = {
      label: '受験者数',
      borderColor: this.dotBlueColor,
      data: [],
      fill: false,
      yAxisID: 'B',
      lineTension: 0,
      // borderWidth: 5,
      borderDash: [10, 10],
      hidden: true,
    }

    this.userExamsInrange.forEach((userExamItem) => {
      let examName = userExamItem.exam.name
      if(examName.length > 15) {
        examName = examName.slice(0,14) + "..."
      }

      labels.push(examName)

      userScore.data.push(userExamItem.userExam.average)
      examScoreAverage.data.push(userExamItem.exam.averageRate)
      userRank.data.push(userExamItem.userExam.position)
      examUserCount.data.push(userExamItem.exam.usersCount)
    })

    this.data = {
      labels: labels,
      datasets: [userScore, examScoreAverage, userRank, examUserCount]
    }

    console.log(this.data);
    
  }

  updateRange() {
    let startDate = this.dateRange.startDate.toString();
    let endDate = this.dateRange.endDate.toString();
    this.$router.push({ query: { start_date: startDate, end_date: endDate } })
  }
}
